import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    padding: '24px 28px',
    border: `1px solid black`,
    background: 'white',
    bottom: '5px',
    left: '5px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    height: 120,
    zIndex: 1,
    userSelect: 'none',

    [theme.breakpoints.down('lg')]: {
      bottom: '80px',
      height: 'unset'
    }
  },

  overlay: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 10001
  },

  img: {
    width: 100,
    height: 100,

    [theme.breakpoints.down('lg')]: {
      width: 60,
      height: 60
    }
  },

  textContainer: {
    display: 'flex',
    flexFlow: 'column',
    marginLeft: 12,
    fontSize: theme.size.base,

    [theme.breakpoints.down('lg')]: {
      fontSize: theme.size.sm
    }
  },

  actionsContainer: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'baseline',
    gap: 6,
    marginTop: '6px',
    justifyContent: 'space-between'
  },

  mainLabel: {
    fontSize: theme.size.lg,

    [theme.breakpoints.down('lg')]: {
      fontSize: theme.size.base
    }
  },

  closeIcon: {
    cursor: 'pointer',
    alignSelf: 'baseline',
    marginLeft: 8
  },

  btnRoot: {
    cursor: 'pointer',
    width: 'auto !important',

    '& label': {
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.size.sm
      }
    }
  },

  refreshIcon: {
    marginRight: 6,
    flexShrink: 0
  }
}))

export default useStyles
